import { render, staticRenderFns } from "./app-version.vue?vue&type=template&id=26cabd7e&scoped=true&"
import script from "./app-version.vue?vue&type=script&lang=js&"
export * from "./app-version.vue?vue&type=script&lang=js&"
import style0 from "./app-version.vue?vue&type=style&index=0&id=26cabd7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cabd7e",
  null
  
)

export default component.exports